const ORDERS_HISTORY_PAGE = {
  number: 'Número',
  numberAbbreviation: 'Nº',
  name: 'Nome',
  review: 'Avaliação',
  open: 'Abrir',
  data: 'Data',
  from: 'De',
  status: 'Status',
  deliveryman: 'Entregador',
  deliverymanInvalidEmailMessage:
    'Digite o email no formato: entregador@seunegocio.com',
  orderPriceAmount: 'Valor do Pedido',
  money: 'R$',
  payment: 'Pagamento',
  deliveryType: 'Entrega',
  discountCode: 'Cupom',
  yes: 'Sim',
  no: 'Não',
  discountValue: 'Desconto',
  errors: {
    largePeriod: 'O intervalo entre as datas é maior que o permitido',
  },
  centerTextHistory: 'Histórico de pedidos',
  orders: 'Pedidos',
  seeMoreOrders: 'Ver mais pedidos',
  noMoreOrders: 'Não há mais pedidos nesse intervalo de data e hora',
  singularAppliedFilter: 'filtro aplicado',
  pluralAppliedFilter: 'filtros aplicados',
  removeFilters: 'Remover filtros',
  singularRemoveFilter: 'Remover filtro',
  filter: 'Filtrar',
  filters: 'Filtros',
  search: 'Buscar',
  apply: 'Aplicar',
  cancel: 'Cancelar',
  filteredBy: 'Filtros ativos:',
  pickedUp: 'Retirado',
  newTable: {
    order: 'Pedido',
    client: 'Cliente',
    orderPriceAmount: 'Valor',
    noOrdersFound: 'Ops, nenhum registro foi encontrado',
  },
  pageSize: {
    DEFAULT: 30,
    FORTY: 40,
    FIFTY: 50,
  },
  noData: 'Nenhum pedido encontrado',
  itensPerPage: 'Itens por página',
  next: 'próxima',
  prev: 'anterior',
  searchInputPlaceholder: 'Buscar nº do pedido, entregador, cliente...',
  period: 'Período',
  ratings: {
    zero: 'Sem avaliações',
    one: '1 estrela',
    two: '2 estrelas',
    three: '3 estrelas',
    four: '4 estrelas',
    five: '5 estrelas',
    stars: 'Estrelas',
    star: 'Estrela',
  },
  paymentMethods: {
    card: 'Cartão',
    creditCard: 'Cartão de crédito na entrega',
    debitCard: 'Cartão de débito na entrega',
    creditCardSimplified: 'Cartão de crédito',
    cash: 'Dinheiro',
    onlinePayment: 'Online Crédito',
    pix: 'Online Pix',
    nupay: 'Online Nubank',
  },
  orderStatus: {
    accepted: 'Aceito',
    pickedUp: 'Entregador retirou',
    enRoute: 'A caminho',
    delivered: 'Entregue',
    userCancelled: 'Cancelado: usuário',
    cancellationRequest: 'Cancelado: entregador',
    abandoned: 'Cancelado: PDV',
    rejected: 'Rejeitado',
    suspect: 'Desconsiderado',
    expired: 'Expirado',
    pocPickedUp: 'Retirado',
    dmAccepted: 'Aceito - entregador',
    dmPickedUp: 'Retirou',
    dmExpired: 'Expirado DM',
    pending: 'Pedido colocado',
    transferred: 'Transferido',
    pocScheduled: 'Programado',
    csCancelledDoc: 'Cancelado',
    waitingCourier: 'Aguardando entregador',
    waitingConsumer: 'Aguardando cliente',
  },
  deliveryTypes: {
    receive: 'Comum',
    scheduled: 'Programado',
    pickup: 'Retirada',
    turbo: 'Turbo',
  },
  segment: {
    macroJourney: 'order',
    microJourney: 'history',
    button: 'button',
    notTracked: 'NOT_TRACKED',
  },
}

export default ORDERS_HISTORY_PAGE
